import React, {FC} from "react"

import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import {HomePageView} from "../types"

interface Props {
  id: string,
  onChangePreview: (view: HomePageView) => void
}

const HomePageChangeView: FC<Props> = (props) => {
  return (
    <Flex id="change-homepage-view" justifyContent="flex-end" alignItems="center">
      <Button primary onClick={props.onChangePreview}>
        <FormattedMessage id="platform.homepage.changeView.to.employeeView" />
      </Button>
    </Flex>
  )
}

export default HomePageChangeView
